var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16671 18.3334C3.70647 18.3334 3.33337 17.9603 3.33337 17.5V2.50002C3.33337 2.03979 3.70647 1.66669 4.16671 1.66669H15.8334C16.2936 1.66669 16.6667 2.03979 16.6667 2.50002V5.00002H15V3.33335H5.00004V16.6667H15V15H16.6667V17.5C16.6667 17.9603 16.2936 18.3334 15.8334 18.3334H4.16671ZM15 13.3334V10.8334H9.16671V9.16669H15V6.66669L19.1667 10L15 13.3334Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.052c80fe.svg";
export { ForwardRef as ReactComponent };